<template>
  <div class="">
    <el-card :class="el_card_class" class="excel-div" v-show="showBox" v-drag ref="excelfa">
      <div class="excel-header">
        <div class="box-flex">
          <el-upload class="upload-demo" ref="upload" accept=".xls,.xlsx,.txt"
            action="https://jsonplaceholder.typicode.com/posts/" :on-change="upload" :show-file-list="false"
            :auto-upload="false">
            <el-button slot="trigger" type="primary" size="mini">选择文件</el-button>
          </el-upload>
          <div style="margin-left: 10px;">
            <p class="table-name">表名：{{ file_name }}</p>
          </div>
        </div>

        <div style="margin-right:40px">
          <el-button v-if="covershow" @click="coverImport" size="mini" type="danger">覆盖并导入</el-button>

          <el-button @click="updateImport" size="mini" type="warning">
            <slot></slot>
          </el-button>
        </div>
      </div>
      <!-- <el-table
        id="loading-container"
        :header-cell-style="{ background: '#92e2845e', color: '#606266' }"
        :data="tableData"
        height="520"
      >
        <el-table-column
          style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
          v-for="item in tabColumn"
          :key="item.label"
          :label="item.label"
          :width="item.width"
          :prop="item.prop"
        >
        </el-table-column>
      </el-table> -->
      <ve-table id="loading-container" border-x border-y ref="goodstableRef" :columns="tabColumn" :fixed-header="true"
        :scroll-width="1800" :maxHeight="`500px`" rowKeyFieldName="rowKey" :table-data="tableData"
        :rowStyleOption="rowStyleOption" :cell-style-option="cellStyleOption"
        :virtual-scroll-option="virtualScrollOption" enable="true" />
      <div class="close-box" @click="hiddleBox">✗</div>
    </el-card>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="centerDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="centerDialogVisible = false"
        >确 定</el-button
      >
    </span> -->
  </div>
</template>
<script>
import { myFixed } from "@/js/public.js";
// import { parse } from "qs";
// import { rFileSize } from "../js/public";
import XLSX from "../../node_modules/xlsx/xlsx.js";
//import Sortable from 'sortable.js' // 该插件用于实现表格可拖拽功能，可不用，它相关的都注释了; 如果将其放开，需要在项目中安装sortablejs 插件；npm install sortablejs --save
export default {
  props: { covershow: { default: true, type: Boolean } },
  data() {
    return {
      tableData: [],
      tabData: [],
      tabColumn: [
        {
          field: "",
          key: "a",
          title: "",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.rowKey + 1;
          }
        },
        {
          field: "item_no",
          key: "item_no",
          title: "货号",
          align: "left",
          width: "12%",
          fixed: "left",
          ellipsis: {
            showTitle: true
          }
        }, {
          field: "barcode",
          key: "barcode",
          title: "商品条码",
          align: "left",
          width: "12%",
          fixed: "left",
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "item_name",
          key: "item_name",
          title: "商品名称",
          align: "left",
          width: "20%",

          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "in_price",
          key: "in_price",
          title: "进价",
          align: "left",
          width: "10%"
        },
        {
          field: "sale_price",
          key: "sale_price",
          title: "售价",
          align: "left",
          width: "10%"
        },
        {
          field: "qty",
          key: "qty",
          title: "入库",
          align: "left",
          width: "10%",

          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "amount",
          key: "amount",
          title: "金额",
          align: "left",
          width: "10%",

          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "advise_price",
          key: "advise_price",
          title: "建议售价",
          align: "left",
          width: "10%",
          edit: false
        },
        {
          field: "price",
          key: "price",
          title: "合约价",
          align: "left",
          width: "10%",
          edit: false
        },
        {
          field: "production_day",
          key: "production_day",
          title: "生产日期",
          align: "left",
          width: "10%",

          ellipsis: {
            showTitle: true
          }
        },
        //
        {
          field: "batch_no",
          key: "batch_no",
          title: "批次号",
          align: "left",
          width: "10%",

          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "vip_price",
          key: "vip_price",
          title: "会员价",
          align: "left",
          width: "10%",

          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "sup_no",
          key: "sup_no",
          title: "供应商",
          align: "left",
          width: "10%",

          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "class_no",
          key: "class_no",
          title: "类别",
          align: "left",
          width: "10%",

          ellipsis: {
            showTitle: true
          }
        },

        {
          field: "item_size",
          key: "item_size",
          title: "规格",
          align: "left",
          width: "10%",

          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "product_area",
          key: "product_area",
          title: "产地",
          align: "left",
          width: "10%",

          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "unit",
          key: "unit",
          title: "单位",
          align: "left",
          width: "10%",

          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "grade",
          key: "grade",
          title: "等级",
          align: "left",
          width: "10%",

          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "life_day",
          key: "life_day",
          title: "保质期",
          align: "left",
          width: "10%",
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "weight_flag",
          key: "weight_flag",
          title: "称重标识",
          align: "left",
          width: "10%",
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "brand_name",
          key: "brand_name",
          title: "品牌",
          align: "left",
          width: "10%",
          ellipsis: {
            showTitle: true
          }
        }
      ],
      text: {},
      file_name: "",
      tabwidth: 0,
      showBox: false,
      el_card_class: "",
      rowStyleOption: {
        clickHighlight: false,
        stripe: true
      },
      //表头样式
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        }
      },
      // 是否开启虚拟滚动
      virtualScrollOption: {
        // 是否开启
        enable: true
      }
    };
  },
  //自定义拖拽指令
  directives: {
    // 自定义拖拽指令，先声明这个指令
    drag(el) {
      // 可就在里写指令的js代码
      const oDiv = el; // 当前元素

      document.onselectstart = () => {
        return false;
      };
      oDiv.onmousedown = e => {
        // 鼠标按下时的鼠标所在的X，Y坐标
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX - oDiv.offsetLeft;
        const disY = e.clientY - oDiv.offsetTop;
        /*         console.log("e.clientX：",e.clientX,"e.clientY：",e.clientY);
        console.log("oDiv.offsetLeft：",oDiv.offsetLeft,"oDiv.offsetTop：",oDiv.offsetTop); */

        document.onmousemove = e => {
          // 通过事件委托，计算移动的距离
          // 因为浏览器里并不能直接取到并且使用clientX、clientY,所以使用事件委托在内部做完赋值
          let l = e.clientX - disX;
          let t = e.clientY - disY;
          /* console.log("document.body.scrollWidth：",document.body.scrollWidth,"document.body.scrollHeight：",document.body.scrollHeight);
          console.log(oDiv.scrollWidth)
          console.log(oDiv.scrollHeight) */
          let left = document.body.scrollWidth - oDiv.scrollWidth;
          let top = document.body.scrollHeight - oDiv.scrollHeight;
          /* console.log(left,top);*/
          // console.log(l,t);
          if (l < 0) {
            l = 0;
          }
          if (l >= left) {
            l = left;
          }
          if (t < 0) {
            t = 0;
          }
          if (t >= top) {
            t = top + 30;
          }
          // 计算移动当前元素的位置，并且给该元素样式中的left和top值赋值
          oDiv.style.left = l + "px";
          oDiv.style.top = t + "px";
        };
        document.onmouseup = e => {
          // 鼠标抬起，清空之前所在的位置，新拖拽的位置已生成并赋值
          document.onmousemove = null;
          document.onmouseup = null;
        };
        // return false不加的话可能导致黏连，拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
        return false;
      };
    }
  },
  mounted() {
    this.loadingInstance = this.$veLoading({
      target: document.querySelector("#loading-container"),
      name: "wave"
    });
  },
  methods: {
    showModel() {
      this.showBox = true;
      /* var resolution = localStorage.getItem("pixel");
      if (resolution <= 700 * 900) {
        this.el_card_class = "el-card-small";
      }
      if (resolution > 700 * 900 && resolution < 1400 * 900) {
        this.el_card_class = "el-card-middle ";
      }
      if (resolution > 1400 * 900) {
      } */
      this.el_card_class = "el-card-large";
    },
    async upload(file, fileList) {
      console.log("file-------------------", file);
      this.file_name = file.name;
      this.$emit("FileName", this.file_name);
      let files = [file.raw];
      // console.log("files---",files);
      // console.log("files---type",typeof file);
      // 取到File
      this.readExcel(files);
    },
    readExcel(files) {
      console.log("files---------------", files);
      // 表格导入
      var that = this;
      this.tableData = [];
      this.tabData = [];
      // this.tabColumn = [];
      if (files.length <= 0) {
        // 如果没有文件名
        return false;
      } else if (!/\.(xls|xlsx|txt)$/.test(files[0].name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      } else if (this.rFileSize(files[0].size) > 0.5) {
        this.warnMessage("表格数据过多，可能造成电脑卡顿。请分成多个表导入。");
        return false;
      }
      const fileReader = new FileReader();

      this.show();
      // console.log(fileReader);
      fileReader.onload = ev => {
        /* if (/\.txt$/.test(ev.name.toLowerCase())) {
          fileReader.readAsText(ev.target.result, "gb2312");
        } */
        console.log("data------------- -- ev", ev);

        const data = ev.target.result;
        console.log("data------------- -- ", data);
        const workbook = XLSX.read(data, {
          type: "binary"
        });

        // console.log("workbook", data);

        const wsname = workbook.SheetNames[0]; // 取第一张表
        console.log("-----------------wsname", wsname);
        const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // 生成json表格内容
        console.log("-----------------ws", ws);
        var tableData = JSON.parse(JSON.stringify(ws));
        /*console.log("tbdata------------",tbdata);
         */
        tableData.forEach(function (item, i, arr) {
          that.tabData[i] = {
            item_no: "",
            barcode: "",
            item_name: "",
            in_price: "",
            sale_price: "",
            advise_price: "",
            amount: "",
            price: "",
            batch_no: "",
            production_day: "",
            vip_price: "",
            sup_no: "",
            class_no: "",
            product_area: "",
            item_size: "",
            unit: "",
            qty: "",
            grade: "",
            life_day: "",
            weight_flag: "",
            brand_name: "",
            rowKey: i
          };
          for (var key in item) {
            switch (key.trim()) {
              case "货号":
                that.tabData[i].item_no = String(item[key]);
                break;
              case "商品条码":
                that.tabData[i].barcode = String(item[key]);
                break;
              case "商品名称":
                that.tabData[i].item_name = item[key]
                  .replace(/\s*/g, "")
                  .replace(/（/g, "(")
                  .replace(/）/g, ")");
                break;
              case "批次号":
                that.tabData[i].batch_no = item[key];
                break;
              case "进价":
                that.tabData[i].in_price = myFixed(Number(item[key]), 4);
                break;
              case "售价":
                that.tabData[i].sale_price = myFixed(Number(item[key]), 2);
                break;
              case "建议售价":
                that.tabData[i].advise_price = myFixed(Number(item[key]), 2);
                break;
              case "金额":
                that.tabData[i].amount = myFixed(Number(item[key]), 2);
                break;
              case "会员价":
                that.tabData[i].vip_price = myFixed(Number(item[key]), 2);
                break;
              case "合约价":
                that.tabData[i].price = myFixed(Number(item[key]), 2);
                break;
              case "生产日期":
                that.tabData[i].production_day = item[key];
                break;
              case "供应商":
                that.tabData[i].sup_no = String(item[key]);
                break;
              case "类别":
                that.tabData[i].class_no = String(item[key]);
                break;
              case "规格":
                that.tabData[i].item_size = String(item[key]).slice(0, 7);
                break;
              case "产地":
                that.tabData[i].product_area = item[key];
                break;
              case "单位":
                that.tabData[i].unit = item[key];
                break;
              case "等级":
                that.tabData[i].grade = item[key];
                break;
              case "入库":
                that.tabData[i].qty = item[key];
                break;
              case "保质期":
                that.tabData[i].life_day = item[key];
                break;
              case "称重标识":
                that.tabData[i].weight_flag = item[key];
                break;
              case "品牌":
                that.tabData[i].brand_name = item[key];
                break;
            }
          }
        });
        // console.log("tbdata---==------------",this.tabData);
        var arr1 = [];
        var arr2 = [];
        for (let i = 0; i < this.tabData.length; i++) {
          if (arr1.indexOf(this.tabData[i].barcode) === -1) {
            arr1.push(this.tabData[i].barcode);
            arr2.push(this.tabData[i]);
          }
        }
        for (var a in arr2) {
          this.tableData.push(arr2[a]);
        }
        // 重写数据
        this.$refs.upload.value = "";
        this.close();
      };
      if (/\.txt$/.test(files[0].name.toLowerCase())) {
        fileReader.readAsText(files[0], "gb2312");
      } else {
        fileReader.readAsBinaryString(files[0]);
      }
    },
    coverImport() {
      this.tableData = this.uniqueFunc(this.tableData, "barcode");
      this.$emit("cover-import", this.tableData);
      this.hiddleBox();
    },
    async updateImport() {
      this.tableData = await this.uniqueFunc(this.tableData, "barcode");
      this.$emit("update-import", this.tableData);
      this.hiddleBox();
    },
    hiddleBox() {
      this.showBox = false;
    },
    show() {
      this.loadingInstance.show();
    },
    close() {
      this.loadingInstance.close();
    },
    //数组去重
    //实现思路 创建一个map实例对象 res => 调用数组的filter方法(浅拷贝数组) => Map.set()
    uniqueFunc(arr, uniId) {
      const res = new Map();
      return arr.filter(
        item => !res.has(item[uniId]) && res.set(item[uniId], 1)
      );
    }
  }
};
</script>
<style scoped lang="less">
.excel-div {
  opacity: 0.8;
}

.box-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.excel-header {
  height: 40px;
  width: 100%;
  padding: 10px 0;
  .box-flex;
}

.container {
  border: none;
  border-radius: 4px;
  background-color: #409eff;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  min-width: 80px;
  /* *zoom: 1; */
}

.upload_file {
  font-size: 20px;
  opacity: 0;
  position: absolute;
  filter: alpha(opacity=0);
  width: 60px;
}

.el-card-large {
  position: fixed;
  width: 964px;
  padding: 5px;
  top: 0;
  left: 10%;
  border-radius: 15px;
  border: 2px solid #ebeef5;
  z-index: 99;
  cursor: move;
  padding: 20px 0 0 10px;
}

.el-card-middle {
  position: fixed;
  width: 964px;
  height: 500px;
  top: 0%;
  left: 0%;
  border-radius: 15px;
  border: 2px solid #ebeef5;
  z-index: 99;
  transform: scale(0.9, 0.9);
  cursor: move;
}

.el-card-small {
  position: fixed;
  width: 964px;
  padding: none;
  top: -10%;
  left: -10%;
  border-radius: 15px;
  border: 2px solid #ebeef5;
  z-index: 99;
  transform: scale(0.65, 0.65);
}

.el-table {
  text-align: center;
  position: relative;
  /* top: 50%; */
  left: 50%;
  transform: translate(-50%, 0);
}

.table-name {
  /* margin-top: -1px; */
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  width: 400px;
}

.el-table-column {
  text-align: center;
}

.close-box {
  display: inline-block;
  text-align: center;
  width: 30px;
  height: 30px;
  position: relative;
  top: -563px;
  right: -921px;
  color: #fff;
  background-color: #f56c6c;
  border-radius: 0 15px 0 15px;
  line-height: 2.2;
  cursor: pointer;
  z-index: 100;
}

/deep/.el-card__body {
  padding: 0 !important;
}
</style>
